(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("material-ui-rte", ["react"], factory);
	else if(typeof exports === 'object')
		exports["material-ui-rte"] = factory(require("react"));
	else
		root["material-ui-rte"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 